import useAuditHistorico from '../../../../components/v2/AuditTimelineV2/useAuditHistorico';

export const useNsirHistorico = (nsirId, { enabled = true } = {}) => useAuditHistorico(
  nsirId ? `nsirs/${nsirId}/historico` : null,
  { enabled },
);

export default useNsirHistorico;
